// Компонент переключения темы

import { Sun, Moon, Monitor } from 'lucide-react';
import { useEffect, useState } from 'react';

type Theme = 'light' | 'dark' | 'system';

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => {
    const stored = localStorage.getItem('theme') as Theme | null;
    return stored || 'system';
  });

  useEffect(() => {
    const root = document.documentElement;
    
    if (theme === 'system') {
      root.removeAttribute('data-theme');
      localStorage.removeItem('theme');
    } else {
      root.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
    }
  }, [theme]);

  return (
    <div className="theme-toggle" role="radiogroup" aria-label="Выбор темы">
      <button
        className={`theme-toggle__btn ${theme === 'light' ? 'theme-toggle__btn--active' : ''}`}
        onClick={() => setTheme('light')}
        role="radio"
        aria-checked={theme === 'light'}
        aria-label="Светлая тема"
        title="Светлая тема"
      >
        <Sun className="theme-toggle__icon" />
      </button>
      <button
        className={`theme-toggle__btn ${theme === 'dark' ? 'theme-toggle__btn--active' : ''}`}
        onClick={() => setTheme('dark')}
        role="radio"
        aria-checked={theme === 'dark'}
        aria-label="Тёмная тема"
        title="Тёмная тема"
      >
        <Moon className="theme-toggle__icon" />
      </button>
      <button
        className={`theme-toggle__btn ${theme === 'system' ? 'theme-toggle__btn--active' : ''}`}
        onClick={() => setTheme('system')}
        role="radio"
        aria-checked={theme === 'system'}
        aria-label="Системная тема"
        title="Системная тема"
      >
        <Monitor className="theme-toggle__icon" />
      </button>
    </div>
  );
}
